import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const FooterSection = () => {
  // Get services from Redux
  const services = useSelector((state) => state.Services || []);

    const handleScroll = () => {
    document.body.scrollTop = 0;
  };

  return (
    <section>
      <div className='pt-3'>
        <div className="container">
          <div className="row footer-padding align-items-start">
            <div className="col-12 col-lg-3 text-center text-lg-start mb-4 mb-lg-0">
              <div className="d-flex justify-content-center justify-content-lg-start">
                <Link to="/" onClick={handleScroll}>
                  <img 
                    style={{width:"200px", maxWidth: "100%"}} 
                    className="cargo-image" 
                    src="SpiritLogo.png" 
                    alt="Spirit Cargo" 
                  />
                </Link>
              </div>
            </div>

            <div className="col-12 col-lg-9">
              <div className="row justify-content-center">
                <div className="col-12 col-sm-6 col-lg-4 text-center text-lg-start mb-4 mb-lg-0">
                  <ul className="list-unstyled ps-0 pt-2">
                    <li className="mb-2">
                      <b className="list-header fw-medium fs-5 lh-sm">About Spirit</b>
                    </li>
                    <Link to="/#location-cards">
                      <li className="list-item fw-normal fs-6 lh-sm mb-1">Our Locations</li>
                    </Link>
                    <Link to="/about-us" onClick={handleScroll}>
                      <li className="list-item fw-normal fs-6 lh-sm mb-1">About Us</li>
                    </Link>
                    <Link to="/#services">
                      <li className="list-item fw-normal fs-6 lh-sm mb-1">Services</li>
                    </Link>
                  </ul>
                </div>

                <div className="col-12 col-sm-6 col-lg-4 text-center text-lg-start mb-4 mb-lg-0">
                  <ul className="list-unstyled ps-0 pt-2">
                    <li className="mb-2">
                      <b className="list-header fw-medium fs-5 lh-sm">Our Services</b>
                    </li>
                    {services.length > 0 ? (
                      services.map((service, index) => (
                        <Link to="/#services" key={index}>
                          <li className="list-item fw-normal fs-6 lh-sm mb-1">
                            {service.Title}
                          </li>
                        </Link>
                      ))
                    ) : (
                      <Link to="/#services">
                        <li className="list-item fw-normal fs-6 lh-sm mb-1">View Our Services</li>
                      </Link>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{  fontFamily: "Scandinavian New", fontWeight: '500', fontSize: '16px', lineHeight: '20px', letterSpacing: '0%', textAlign: 'center', color: '#fff'}}>
          © Copyright 2025 Spirit Air Cargo Handling. All Rights Reserved.
        </div>
      </footer>
    </section>
  );
};

export default FooterSection;